import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  image: string;
}

const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    container: {
      width: '100%',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      position: 'absolute',
      top: 0,

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 0, 2),
        position: 'unset',
      },

      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,

        [theme.breakpoints.only('sm')]: {
          marginBottom: theme.spacing(4),
        },
      },
    },

    contentHeader: {
      minHeight: 80,
      backgroundColor: theme.palette.primary.light,
      backgroundImage: ({ image }) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '1%',
      borderRadius: theme.spacing(1.8, 1.8, 0, 0),

      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(4, 0),
      },

      '& > div': {
        padding: theme.spacing(2, 0, 0, 13),
        justifyContent: 'space-between',
      },
      '& h3, & p': {
        color: theme.palette.primary.contrastText,
      },
      '& p': {
        fontWeight: theme.typography.fontWeightBold,
      },
      '& h3': {
        fontSize: theme.typography.pxToRem(13),
      },
    },

    contentContainer: {
      minHeight: '60vh',
      marginTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& > figure': {
        marginBottom: theme.spacing(5),

        '& > img': {
          width: '100%',
          maxWidth: 225,
          height: 'auto',
        },
      },
    },

    form: {
      minHeight: '30vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      [theme.breakpoints.up('sm')]: {
        minHeight: 'unset',
      },
    },
  })
);

export default useStyles;
